import { Alert, CircularProgress, Stack, Typography } from "@mui/material";
import { useSettings } from "./hooks/useSettings";
import { SettingsForm } from "./components/SettingsForm";

export default function SettingsPage() {
  const {data, isLoading, isError} = useSettings();

  if (isLoading) {
    return <CircularProgress/>;
  }
  if (isError || !data) {
    return <Alert severity="error">Could not load settings</Alert>;
  }

  return (
    <Stack spacing={3}>
      <Typography variant="h5">Settings</Typography>
      <SettingsForm snapshot={data}/>
    </Stack>
  );
}
